import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AuthRestConnectorService } from "app/core/authentication/services/auth-rest-connector.service";
import { LanguageTranslationComponent } from "app/login/components/language-translation/language-translation.component";
import { PrivacyPolicyComponent } from "app/login/components/privacy-policy/privacy-policy.component";
import { TermsOfUseComponent } from "app/login/components/terms-of-use/terms-of-use.component";
import { MaterialModule } from "app/material.module";
import { GlobalConstants } from "app/shared/constants/globalconstants";
import { SiteLogoModule } from "app/site-logo/site-logo.module";

import { EndUserAgreementComponent } from "./components/end-user-agreement/end-user-agreement.component";
import { SSOAccessOnlyComponent } from "./components/sso-access-only/sso-access-only.component";
import { LoginComponent } from "./components/login/login.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { PasswordResetComponent } from "./components/password-reset/password-reset.component";
import { LoginRoutingModule, routedComponents } from "./login-routing.module";
import { MFAComponent } from "./components/mfa/mfa.component";

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    TranslateModule,
    SiteLogoModule,
  ],
  providers: [AuthRestConnectorService, GlobalConstants],
  exports: [
    LoginComponent,
    LogoutComponent,
    PrivacyPolicyComponent,
    TermsOfUseComponent,
    PasswordResetComponent,
  ],
  entryComponents: [
    EndUserAgreementComponent,
    SSOAccessOnlyComponent,
    TermsOfUseComponent,
    PrivacyPolicyComponent,
    MFAComponent,
  ],
  declarations: [
    routedComponents,
    PasswordResetComponent,
    EndUserAgreementComponent,
    SSOAccessOnlyComponent,
    TermsOfUseComponent,
    PrivacyPolicyComponent,
    LanguageTranslationComponent,
    LoginComponent,
    MFAComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginModule {}
